import type { ApiError } from '@/types/api.types';

type TranslateFn = (key: string) => string;

export function mapSettingsError(error: ApiError, t: TranslateFn, fallbackKey: string): string {
  switch (error.code) {
    case 'UNAUTHORIZED':
      return t('settings.errors.unauthorized');
    case 'FORBIDDEN':
      return t('settings.errors.forbidden');
    case 'ACCOUNT_NOT_FOUND':
      return t('settings.errors.accountNotFound');
    case 'CLOSURE_NOT_FOUND':
      return t('settings.errors.closureNotFound');
    case 'VALIDATION_ERROR':
      return t('settings.errors.validationError');
    case 'INTERNAL_SERVER_ERROR':
      return t('settings.errors.serverError');
    default:
      return t(fallbackKey);
  }
}
